import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getMe } from '../../services/authService';
import { TOKEN_KEY, USER_ROLE_KEY } from '../../utils/constants';

const AdminPrivateRoute: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | null>(null);
    const [isAdmin, setIsAdmin] = React.useState<boolean>(false);

    React.useEffect(() => {
        const checkAuth = async () => {
            const token = localStorage.getItem(TOKEN_KEY);
            if (!token) {
                localStorage.removeItem(USER_ROLE_KEY);
                setIsAuthenticated(false);
                setIsAdmin(false);
                return;
            }

            try {
                const userData = await getMe();
                // Check for 'admin' role
                const role = userData?.role ?? userData?.user?.role;

                if (role === 'admin') {
                    setIsAuthenticated(true);
                    setIsAdmin(true);
                    localStorage.setItem(USER_ROLE_KEY, 'admin');
                } else {
                    // Authenticated but not admin
                    console.log('Access denied: User is not admin', role);
                    setIsAuthenticated(true);
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error('Admin auth check failed:', error);
                setIsAuthenticated(false);
                setIsAdmin(false);
                localStorage.removeItem(TOKEN_KEY);
                localStorage.removeItem(USER_ROLE_KEY);
            }
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (isAuthenticated && !isAdmin) {
        // Redirect non-admins to their respective dashboards or login
        // If we are here, we are logged in but not admin.
        // We could redirect to /dashboard (student) or /ep-dashboard (EP) based on role,
        // but for safety, let's redirect to login which will handle routing or root.
        // Actually, let's just go to root '/' which handles redirects based on auth.
        // Or if we know the role, we could be smarter. 
        // For now, redirect to login to be safe.
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default AdminPrivateRoute;
